/**
 * Schede prodotto di collezioni e ricerca: i pallini colore (snippets/gf-color-swatches.liquid, modo 'card-switch')
 * cambiano la scheda senza aprire il prodotto (richiesta di Donato, 16/10): foto, colore, prezzo e link passano
 * al prodotto di quel colore. «Aggiungi rapido» e il cuore della lista desideri sono legati al prodotto di partenza:
 * dopo il cambio si nascondono, così non si aggiunge il colore sbagliato.
 */
const WIDTHS = [400, 600, 800, 1000, 1200];

function srcset(url) {
  return WIDTHS.map((width) => `${url.replace(/([?&])width=\d+/, `$1width=${width}`)} ${width}w`).join(', ');
}

/** annuncio discreto per i lettori di schermo: colore e prezzo mostrati */
function announce(text) {
  let region = document.getElementById('GfSwatchStatus');
  if (!region) {
    region = Object.assign(document.createElement('p'), { id: 'GfSwatchStatus', className: 'visually-hidden' });
    region.setAttribute('role', 'status');
    document.body.append(region);
  }
  region.textContent = '';
  requestAnimationFrame(() => (region.textContent = text));
}

function switchCard(button) {
  const card = button.closest('product-card, .product-card, .gf-pcard');
  if (!card || button.getAttribute('aria-pressed') === 'true') return;
  const { url, color, title, available, images = '', price = '', worn } = button.dataset;
  const list = images.split('|').filter(Boolean);

  // link della scheda (immagine, nome, link invisibile sopra la scheda)
  card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    if (link.closest('[data-gf-swatch]') || link.classList.contains('gf-dots__more')) return;
    link.href = url;
    // il nome del link segue il prodotto mostrato
    if (title && link.hasAttribute('aria-label')) link.setAttribute('aria-label', title);
  });

  // foto indossata o still life (tag del catalogo): decide come sta la foto nel riquadro (assets/gf-photo-fit.js)
  card.querySelectorAll('.card-gallery').forEach((el) => el.toggleAttribute('data-gf-worn', worn === 'true'));
  if (card.matches('.gf-pcard')) card.toggleAttribute('data-gf-worn', worn === 'true');

  // foto: una per diapositiva, ripetendo l'ultima se il colore ne ha meno
  const imgs = card.querySelectorAll('.card-gallery img, .gf-pcard__img');
  if (list.length) {
    imgs.forEach((img, i) => {
      const next = list[Math.min(i, list.length - 1)];
      img.src = next;
      img.srcset = srcset(next);
      if (title && img.getAttribute('alt')) img.alt = title;
    });
  }

  // colore scritto accanto ai pallini
  const label = card.querySelector('.gf-cardname__color, .gf-pcard__color');
  const text = label && [...label.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
  if (text) text.textContent = color + (available === 'false' ? ` · ${button.getAttribute('aria-label').split(', ').pop()}` : '');

  // prezzo del colore scelto (stesso markup di Horizon)
  const priceEl = card.querySelector('product-price, .gf-pcard__price');
  if (priceEl && price) {
    const template = document.createElement('template');
    template.innerHTML = price;
    const fresh = template.content.firstElementChild;
    const old = priceEl.querySelector(':scope > div');
    if (old && fresh) old.replaceWith(fresh);
    else priceEl.innerHTML = price;
  }

  // ciò che resta legato al prodotto di partenza
  card.querySelectorAll('quick-add-component, .quick-add, [class*="WishlistIcon__Wrapper"], .product-badges, .gf-cardname__new').forEach((el) => {
    el.hidden = true;
  });

  announce(`${color}${priceEl ? `, ${priceEl.textContent.trim().replace(/\s+/g, ' ')}` : ''}`);

  card.querySelectorAll('[data-gf-swatch]').forEach((other) => {
    const on = other === button;
    other.setAttribute('aria-pressed', String(on));
    other.classList.toggle('is-current', on);
  });
}

if (!window.gfCardSwatch) {
  window.gfCardSwatch = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-gf-swatch]');
    if (!button) return;
    // il pallino sta sopra il link della scheda: il clic cambia colore, non apre il prodotto
    event.preventDefault();
    event.stopPropagation();
    switchCard(button);
  });
}
